const initSwiper = ({ block }) => {
  new Swiper(`[data-block="${block}"]`, {
    loop: true,
    parallax: true,
    // Default parameters
    slidesPerView: 1,
    spaceBetween: 10,
    // Responsive breakpoints
    breakpoints: {
      640: {
        slidesPerView: 2,
        spaceBetween: 20,
      },
      1024: {
        slidesPerView: 3,
        spaceBetween: 20,
      },
    },
    pagination: {
      el: `[data-block="${block}"] .gh-posts-swiper-pagination`,
      clickable: true,
      bulletClass: 'gh-posts-swiper-pagination-bullet',
      bulletActiveClass: 'gh-posts-swiper-pagination-bullet-active',
      renderBullet: function (_, className) {
        return `<div class="${className}"><span></span></div>`;
      },
    },
    navigation: {
      prevEl: `[data-block="${block}"] .gh-posts-swiper-button-prev`,
      nextEl: `[data-block="${block}"] .gh-posts-swiper-button-next`,
    },
  });
};

const initPostsSwiper = () => {
  const postsSwipers = document.querySelectorAll('.gh-posts-swiper');
  if (postsSwipers.length) {
    postsSwipers.forEach((swiper) => {
      const blockName = swiper.dataset.block;
      initSwiper({ block: blockName });
    });
  }
};

export { initPostsSwiper };
